export default __webpack_public_path__ + "adc767e63569c7db97a6c54e568ada85.ico";